const Icons = [
    { key: 'fa-robot', name: 'Robot' },
    { key: 'fa-otter', name: 'Otter' },
    { key: 'fa-hippo', name: 'Hippo' },
    { key: 'fa-fish', name: 'Fish' },
    { key: 'fa-dragon', name: 'Dragon' },
    { key: 'fa-kiwi-bird', name: 'Kiwi bird' },
    { key: 'fa-worm', name: 'Worm' },
    { key: 'fa-spider', name: 'Spider' },
    { key: 'fa-shrimp', name: 'Shrimp' },
    { key: 'fa-shield-dog', name: 'Shield dog' },
    { key: 'fa-shield-cat', name: 'Shield cat' },
    { key: 'fa-mosquito', name: 'Mosquito' },
    { key: 'fa-locust', name: 'Locust' },
    { key: 'fa-horse-head', name: 'Horse head' },
    { key: 'fa-horse', name: 'Horse' },
    { key: 'fa-frog', name: 'Frog' },
    { key: 'fa-fish-fins', name: 'Fish fins' },
    { key: 'fa-dove', name: 'Dove' },
    { key: 'fa-dog', name: 'Dog' },
    { key: 'fa-crow', name: 'Crow' },
    { key: 'fa-cow', name: 'Cow' },
    { key: 'fa-cat', name: 'Cat' },
    { key: 'fa-house', name: 'House' },
    { key: 'fa-magnifying-glass', name: 'Magnifying glass' },
    { key: 'fa-download', name: 'Download' },
    { key: 'fa-image', name: 'Image' },
    { key: 'fa-envelope', name: 'Envelope' },
    { key: 'fa-star', name: 'Star' },
    { key: 'fa-face-smile', name: 'Face smile' },
    { key: 'fa-arrow-up-from-bracket', name: 'Rrrow up from bracket' },
    { key: 'fa-database', name: 'Database' },
    { key: 'fa-khanda', name: 'Khanda' },
    { key: 'fa-jet-fighter', name: 'Jet fighter' },
    { key: 'fa-jedi', name: 'Jedi' },
]
export default Icons;